import type { FarmUserPermissionName } from "@/constants/permissions"
import {
  AlertDialog,
  AlertDialogScrollView,
  AlertDialogBodyText,
  Divider,
  AppText,
  Heading,
  Box,
} from "@/theme"
import { useTranslation } from "react-i18next"

export function FarmUserPermissionHelpDialog({
  helpKey,
  onClose,
}: {
  helpKey: FarmUserPermissionName | undefined
  onClose: () => void
}) {
  const { t } = useTranslation("farmUserPermissions")
  let bodyText: string | undefined
  if (helpKey) {
    bodyText = t(`${helpKey}.extendedDescription`)
    return (
      <AlertDialog
        IconComponent={"Permissions"}
        isOpen={Boolean(helpKey)}
        titleElement={t("aboutFarmUserPermissions")}
        onClose={onClose}
      >
        <AlertDialogScrollView>
          <AlertDialogBodyText>
            {t("farmUserPermissionsAllowYouTo")}
          </AlertDialogBodyText>
          <Divider my={"$4"} />
          <AppText colorScheme={"secondary"}>{t(`thisPermission`)}</AppText>
          <Heading variant={"h4"}>{t(`${helpKey}.displayName`)}</Heading>
          <Box mt={"$2"} />
          <AlertDialogBodyText>{bodyText}</AlertDialogBodyText>
        </AlertDialogScrollView>
      </AlertDialog>
    )
  }
  return null
}
